<template>
  <el-col v-if="!isMobile" :lg="6">
    <statistics-by-bids />

    <statistic-by-logist />

    <div class="csv-download-content">
      <span>Экспорт водителей за последние дни:</span>
      <div class="csv-download-content-wrap">
        <div class="csv-download-content-wrap__item">
          <div class="csv-download-content-wrap__item-input">
            <span style="margin-right: 8px">с</span>
            <el-date-picker
              v-model="dateStart"
              :clearable="false"
              type="date"
              placeholder="дата"
              :picker-options="pickerOptions"
            />
          </div>
          <div class="csv-download-content-wrap__item-input">
            <span style="margin-right: 8px">по</span>
            <el-date-picker
              v-model="dateEnd"
              :clearable="false"
              type="date"
              placeholder="дата"
              :picker-options="pickerOptions"
            />
          </div>
          <vue-json-to-csv
            style="display: none"
            :json-data="preredDriverList"
            :separator-excel="true"
            :csv-title="message"
          >
            <el-button ref="fileInput" />
          </vue-json-to-csv>
        </div>
        <div>
          <el-button
            class="csv-download-content-wrap__item-btn"
            icon="el-icon-download"
            type="primary"
            :loading="loadingDriver"
            style="padding: 12px 8px; height: 40px; max-height: 40px !important"
            @click="downloadDriverData"
          />
        </div>
      </div>
    </div>

    <div class="csv-download-content">
      <span>Скачать реестр:</span>
      <div class="reestr-buttons">
        <el-button
          class="reestr-buttons__item"
          @click="handleLoadRiester('today')"
        >
          За сегодня
        </el-button>
        <el-button
          class="reestr-buttons__item"
          @click="handleLoadRiester('tomorrow')"
        >
          За завтра
        </el-button>
      </div>
    </div>
    <div class="csv-download-content">
      <statistic-by-responses />
    </div>
  </el-col>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDate, defaultDateRu } from '@/datas/DateFormats'
import {
  getBeforeDay,
  getDateOfCertainFormat,
  getFuturePeriod,
  getNow,
} from '@/helpers/date'
import StatisticByLogist from '@/views/Home/StatisticByLogist/StatisticByLogist.vue'
import StatisticByResponses from '@/views/Home/StatisticByResponses/StatisticByResponses'
import StatisticsByBids from '@/views/Home/StatisticsByBids/StatisticsByBids.vue'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'

const RespAPI = RepositoryFactory.get('responses')
const DocumentAPI = RepositoryFactory.get('document')

export default {
  name: 'StatisticByUser',
  components: {
    StatisticByResponses,
    StatisticsByBids,
    StatisticByLogist,
    VueJsonToCsv,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      dateStart: getBeforeDay(10, defaultDate),
      dateEnd: getNow(defaultDate),
      countDownloadDay: 1,
      loadingDriver: false,
      preredDriverList: [],
    }
  },
  computed: {
    message() {
      const { dateStart, dateEnd } = this
      let title = 'Данные водителей'

      if (dateStart && dateEnd) {
        title += ` с  ${getDateOfCertainFormat(dateStart, defaultDateRu)}`
        title += ` по ${getDateOfCertainFormat(dateEnd, defaultDateRu)}`
      }

      return title
    },
  },
  methods: {
    handleChangeCount(value) {
      this.countDownloadDay = value
    },
    async downloadDriverData() {
      const { dateStart, dateEnd } = this

      this.loadingDriver = true
      let dateEndPlusOne = moment(dateEnd).add(1, 'd').format('YYYY-MM-DD')

      RespAPI.downloadDriverData({
        load_day_from: getDateOfCertainFormat(dateStart, defaultDate),
        load_day_before: getDateOfCertainFormat(dateEndPlusOne, defaultDate),
      })
        .then(({ data }) => {
          const { items } = data

          this.preparedDriverTable(items)
          this.$message({
            type: items.length ? 'success' : 'error',
            message: items.length
              ? 'Данные загруженны'
              : `${this.message} отсутвуют`,
          })
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loadingDriver = false))
    },
    preparedDriverTable(value = []) {
      this.preredDriverList = []

      if (value.length > 0) {
        this.preredDriverList = value
          .map((item, index) => ({
            '#': index + 1,
            'Фамилия Имя Отчество': item.driver.fio || 'Имя не найденно',
            Телефон: item.driver.phone || 'Телефон не найден',
            Дата: item['load-day'].load_date || 'Дата не найдена',
          }))
          .sort((a, b) => new Date(a['Дата']) - new Date(b['Дата']))

        if (this.preredDriverList.length > 0) {
          this.$nextTick(() => this.$refs?.fileInput?.$el.click())
        }
      }
    },
    async handleLoadRiester(flag) {
      const currentDate =
        flag === 'today'
          ? getNow('YYYY-MM-DD')
          : getFuturePeriod('YYYY-MM-DD', 1)

      const path = `${DocumentAPI.getRiester()}&date_to=${currentDate}&date_from=${currentDate}`

      this.downloadRegistry({
        path,
        blank: 1,
      })
    },
  },
}
</script>

<style lang="sass">
.csv-download
  &-content
    width: 340px
    display: flex
    margin-left: 20px
    margin-top: 20px
    font-size: 12px
    color: #606266
    font-weight: 500
    flex-direction: column
    .reestr-buttons
      display: flex
      justify-content: space-between
      margin-top: 8px
      &__item
        width: 47%
  &-content-wrap
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: 8px
  &-content-wrap__item
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
  &-content-wrap__item-input
    display: flex
    align-items: center
    width: 145px
    margin-right: 8px
    max-height: 40px !important
    .el-input--suffix .el-input__inner
      padding-right: 0 !important
</style>
